export const ANONYMOUS_ROUTES = {
    AUTH: "/auth",
    SIGN_IN: "/auth/sign_in",
    SIGN_UP: "/auth/sign_up",
    TERMS: "/terms",
    UPDATE_PASSWORD: "/auth/update_password",
};

export const LOGGED_IN_ROUTES = {
    AGRI_SOLUTION: "/agri-solution",
    AGRI_SOLUTION_FIRST_STEP: "/agri-solution/crop",
    AGRI_SOLUTION_SECOND_STEP: "/agri-solution/soil",
    AGRI_SOLUTION_THIRD_STEP: "/agri-solution/results",
    AGRI_SOLUTION_FORTH_STEP: "/agri-solution/farm",
    AGRI_SOLUTION_FIFTH_STEP: "/agri-solution/customize",
    AGRI_SOLUTION_RELEASE_CHART: "/agri-solution/releaseChart",
    SOLUTION: "/solution",
    SOLUTION_FIRST_STEP: "/solution/temperature",
    SOLUTION_SECOND_STEP: "/solution/result",
    ABOUT: "/about",
    SAVED_ITEMS: "/saved-items",
    CONTACT_US: "/contact-us",
    USER_AREA: "/UserAreaPage",
};
